import Section from './FinestWhitesSection'
import isEmpty from './FinestWhitesIsEmpty'

export default { Section, isEmpty }
